'use strict';

var AjaxAPI = {};

AjaxAPI.Base = require('./Base');
AjaxAPI.Form = require('./Form');
AjaxAPI.ImmediateRequest = require('./ImmediateRequest');
AjaxAPI.Request = require('./Request');

module.exports = AjaxAPI;


//////////////////
// WEBPACK FOOTER
// ./mits/AjaxAPI/index.js
// module id = 23
// module chunks = 0